<template>
  <div v-if="$route.name === 'Transfers'">
    <PageHeader :breadcrumRoutes="routes" title="Traspaso de pólizas">
      <template #buttons>
        <a-button type="primary" @click="openTransferModal">
          Crear traspaso
        </a-button>
      </template>
    </PageHeader>

    <a-card class="mt-2">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col>
          <a-typography-title :level="4" class="text-gray-8 mb-0">
            Stock traspaso de pólizas
          </a-typography-title>
        </a-col>
      </a-row>
      <a-row class="mt-3">
        <a-col :span="24">
          <TransfersTable />
        </a-col>
      </a-row>
    </a-card>
  </div>
  <router-view :key="$route.path" />
</template>

<script setup>
import { useRouter } from 'vue-router';
import PageHeader from '@/components/page-header.vue';
import TransfersTable from '@/components/tables/transfers-table.vue';

const routes = [
  {
    breadcrumbName: 'Traspaso de pólizas'
  }
];
const router = useRouter();

// * Transfer requests
const openTransferModal = () => {
  router.push({ name: 'TransferCreation' });
};
</script>
